import React from "react";
import "./modal.scss";
import ProductCardTheme2 from "components/ProductCardTheme2";
import { useGetProductsFromUpc } from 'hooks/useGetProductsFromUpc';
import { useDispatch, useSelector } from 'react-redux';
import { setCouponDescriptionModalVisible } from 'redux/actions';
import { useClipCouponDetails } from 'hooks/useClipCouponHandlers';
import { useLockBodyScroll } from 'hooks/useLockBodyScroll';

const CouponDescription = () => {
  const dispatch = useDispatch();
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);

  const {
    couponCartList,
    addCouponToCartListLoading,
    removeCouponToCartListLoading,
    couponDescriptionModalVisible,
    selectedCoupon: coupon,
  } = useSelector(({cartCoupon}) => cartCoupon)

  const {CouponUPCs = []} = coupon ?? {};
  const { products, isLoading } = useGetProductsFromUpc({ upcs: CouponUPCs }, couponDescriptionModalVisible);
  const { handleAddToCart, handleRemoveCouponToCart } = useClipCouponDetails(coupon);

  useLockBodyScroll(couponDescriptionModalVisible);
  
  if (!coupon) return null;
  if (!couponDescriptionModalVisible) return null;

  const offerId = coupon.offer_id;
  const addedCoupon = couponCartList?.find(c => c.offer_id === coupon.offer_id);

  function ClipButtonLabel() {
    if (!isUserLoggedIn) return <>Sign in to Clip</>;

    if (addCouponToCartListLoading || removeCouponToCartListLoading) {
      return <>Loading...</>;
    }

    if (addedCoupon) {
      return <>Unclip</>;
    }

    return <>Click to Clip</>;
  }

  return  <div className="modalContainer">
    <div className="modal-wrap">
  <div className="modal">
  <button className="close-btn" onClick={() => dispatch(setCouponDescriptionModalVisible(!couponDescriptionModalVisible))}>
            <i className="fa-solid fa-xmark"></i>
          </button>
    <header className="modal_header">
      <h2 className="modal_header-title"> {coupon.title} </h2>
    </header>
    <main className="modal_content">
      <div className="content-image">
        <img src={coupon.image_path} alt="couponimg" />
      </div>
      <div className="content-desc">{coupon.details}</div>
    </main>

    <div className="expireContent">
      <p>Coupon Expires On: {coupon.expires_on}</p>
      <footer className="modal_footer">
        <div className="modal_footer_btn">
          <div className="addBtn">
            <button
              onClick={() => {
                addedCoupon
                  ? handleRemoveCouponToCart(offerId)
                  : handleAddToCart();
              }}>
              {addedCoupon ? <UnClipImage /> : <CartIcon />}
              <span> <ClipButtonLabel /> </span>
            </button>
          </div>
          <button className="modal-close" onClick={() => dispatch(setCouponDescriptionModalVisible(!couponDescriptionModalVisible))}>
            Close
          </button>
        </div>
      </footer>
    </div>
      {isLoading 
      ? <div>Loading...</div> 
      : <div className="coupon-product">
          {products?.map(p => <ProductCardTheme2 product={p} key={p.id} />)}
        </div>
      }
    </div>     
  </div>
</div>
};

function CartIcon() {
    return <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      height={16}
      width={16}
      viewBox="0 0 25.708 25.708"
      xmlSpace="preserve"
      stroke="0.5px"
      className="w-5 h-5 fill-current text-red-500"
    >
      <g>
        <path d="M23.354,7.23c0,0-1.439-1.239-2.652-0.548c-0.934,0.537-6.867,3.514-9.514,4.84L7.44,9.379 
        C7.847,8.658,7.915,7.824,7.696,7.02c-0.277-1.016-1.01-1.979-2.092-2.598C3.659,3.307,1.321,3.731,0.388,5.369 
        c-0.416,0.723-0.484,1.563-0.266,2.373c0.277,1.016,1.01,1.98,2.092,2.602c0.478,0.27,0.976,0.449,1.471,0.541v0.001 
        c0.004,0.001,0.008,0.001,0.012,0.003c0.039,0.006,0.084,0.015,0.127,0.02c3.086,0.459,4.664,1.33,5.43,1.944 
        c-0.766,0.616-2.344,1.485-5.43,1.945c-0.043,0.005-0.088,0.013-0.127,0.019c-0.004,0.002-0.008,0.002-0.012,0.004l0,0 
        c-0.494,0.092-0.992,0.271-1.471,0.542c-1.082,0.622-1.814,1.585-2.092,2.602c-0.219,0.808-0.15,1.648,0.266,2.375 
        c0.934,1.635,3.271,2.061,5.217,0.946c1.082-0.621,1.814-1.584,2.092-2.602c0.219-0.803,0.15-1.635-0.256-2.357l3.748-2.142 
        c2.646,1.325,8.58,4.305,9.514,4.839c1.213,0.691,2.652-0.547,2.652-0.547l-9.838-5.624L23.354,7.23z M5.843,8.487 
        C5.417,9.229,4.173,9.35,3.126,8.751C2.511,8.401,2.048,7.843,1.89,7.263C1.821,7.004,1.776,6.625,1.978,6.278 
        c0.424-0.741,1.668-0.862,2.715-0.264c0.625,0.355,1.074,0.898,1.234,1.488C5.999,7.758,6.04,8.139,5.843,8.487z 
        M5.927,18.203c-0.16,0.591-0.609,1.133-1.234,1.489c-1.047,0.6-2.291,0.478-2.715-0.265c-0.201-0.348-0.156-0.726-0.088-0.982 
        c0.158-0.582,0.621-1.14,1.236-1.492c1.047-0.598,2.291-0.477,2.717,0.266C6.04,17.569,5.999,17.947,5.927,18.203z" />
        <rect x="15.864" y="12.367" width="2.41" height="0.992" />
        <rect x="19.478" y="12.367" width="2.408" height="0.992" />
        <rect x="23.302" y="12.357" width="2.406" height="0.991" />
      </g>
    </svg>
}

function UnClipImage() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 19" fill="none">
          <path d="M23.3538 4.23001C23.3538 4.23001 21.9148 2.99101 20.7018 3.68201C19.7678 4.21901 13.8348 7.19601 11.1878 8.52201L7.43983 6.37901C7.84683 5.65801 7.91483 4.82401 7.69583 4.02001C7.41883 3.00401 6.68583 2.04101 5.60383 1.42201C3.65883 0.307014 1.32083 0.731014 0.387832 2.36901C-0.0281684 3.09201 -0.0961684 3.93201 0.121832 4.74201C0.398832 5.75801 1.13183 6.72201 2.21383 7.34401C2.69183 7.61401 3.18983 7.79301 3.68483 7.88501C3.68883 7.88601 3.69283 7.88701 3.69683 7.88901C3.73583 7.89501 3.78083 7.90401 3.82383 7.90901C6.90983 8.36801 8.48783 9.23901 9.25383 9.85301C8.48783 10.469 6.90983 11.338 3.82383 11.798C3.78083 11.803 3.73583 11.811 3.69683 11.817C3.69283 11.819 3.68883 11.819 3.68483 11.821C3.19083 11.913 2.69283 12.092 2.21383 12.363C1.13183 12.985 0.399832 13.948 0.121832 14.965C-0.0971684 15.773 -0.0281684 16.613 0.387832 17.34C1.32183 18.975 3.65883 19.401 5.60483 18.286C6.68683 17.665 7.41883 16.702 7.69683 15.684C7.91583 14.881 7.84683 14.049 7.44083 13.327L11.1888 11.185C13.8348 12.51 19.7688 15.49 20.7028 16.024C21.9158 16.715 23.3548 15.477 23.3548 15.477L13.5168 9.85301L23.3538 4.23001ZM5.84283 5.48701C5.41683 6.22901 4.17283 6.35001 3.12583 5.75101C2.51083 5.40101 2.04783 4.84301 1.88983 4.26301C1.82083 4.00401 1.77583 3.62501 1.97783 3.27801C2.40183 2.53701 3.64583 2.41601 4.69283 3.01401C5.31783 3.36901 5.76683 3.91201 5.92683 4.50201C5.99883 4.75801 6.03983 5.13901 5.84283 5.48701ZM5.92683 15.203C5.76683 15.794 5.31783 16.336 4.69283 16.692C3.64583 17.292 2.40183 17.17 1.97783 16.427C1.77683 16.079 1.82183 15.701 1.88983 15.445C2.04783 14.863 2.51083 14.305 3.12583 13.953C4.17283 13.355 5.41683 13.476 5.84283 14.219C6.03983 14.569 5.99883 14.947 5.92683 15.203Z" fill="currentColor" />
        </svg>
}

export default CouponDescription;
